import { createContext, useContext } from "react";
import type { Session, User } from "@supabase/supabase-js";

export interface AuthContextType {
  session: Session | null;
  user: User | null;
  loading: boolean;
  signOut: () => Promise<void>;
}

// Lightweight context + hook only. The real provider (which imports the
// Supabase SDK) lives in AuthProvider.tsx and is loaded lazily so that
// components using `useAuth()` (e.g. <Header />) don't pull Supabase into
// the initial bundle.
export const AuthContext = createContext<AuthContextType>({
  session: null,
  user: null,
  loading: true,
  signOut: async () => {},
});

export const useAuth = () => useContext(AuthContext);
